import React from 'react'

import { scroll } from '@uiw/codemirror-extensions-events'

import { Editor } from '../Editor'

type PropsType = {
  language: string
  onChange: (lines: string[], code: string) => void
  setScrollTop: (scroll: number) => void
}

export const CodingEditor = ({ language, onChange, setScrollTop }: PropsType) => {
  const onChangeHandler = (value: string, view: any) => {
    const lines = view.state.doc.text

    onChange(lines, value)
  }

  const eventExt = scroll({
    scroll: (evt: any) => {
      setScrollTop(evt.target.scrollTop)
    },
  })

  return (
    <Editor
      language={language}
      editable={true}
      onChange={onChangeHandler}
      extraExtensions={[eventExt]}
    />
  )
}
